<template>
  <div class="ui-page">
    <AppCard v-if="data.results.length" design="new" variant="table">
      <AppDataTable design="new" density="dense" :rows="data.results" :columns="columns" min-width="1200px" clickable @row-click="openRow($event.event, $event.row)">
        <template #cell-run="{ row }"><AppTableText :text="`#${row.id}`" /></template>
        <template #cell-lead="{ row }"><AppTableText :text="row.lead && row.lead.name" /></template>
        <template #cell-stage="{ row }"><AppTableText :text="display(row.stage)" /></template>
        <template #cell-manager="{ row }"><AppTableUser :name="row.manager_at_start ? display(row.manager_at_start) : ''" /></template>
        <template #cell-policy="{ row }"><AppTableText :text="`${row.policy.name} · v${row.policy.version}`" /></template>
        <template #cell-status="{ row }"><AppStatusBadge design="new" compact :tone="statusTone(row.status)" :label="display(row.status)" /></template>
        <template #cell-progress="{ row }">{{ processedCount(row.progress) }} / {{ row.progress.total }}</template>
        <template #cell-started="{ row }"><AppTableText :text="dateTime(row.started_at)" /></template>
        <template #cell-next="{ row }"><AppTableText :text="dateTime(row.next_scheduled_at)" /></template>
        <template #cell-attention="{ row }">
          <div v-if="row.has_attention" class="ui-cell-inline"><AppStatusBadge v-for="reason in row.attention_summary" :key="`${reason.code}:${reason.level}`" design="new" :tone="reason.level === 'send_failed' ? 'red' : 'amber'" compact :label="attentionLabel(reason)" /></div>
          <span v-else>—</span>
        </template>
      </AppDataTable>
    </AppCard>
    <AppNoResults v-else design="new" title="No runs found" text="No saved runs match this selection." />
    <AppPagination design="new" placement="embedded" :page="page" :pages="data.pages" :count="data.count" :visible-count="data.results.length" :page-size="40" @change="$emit('page', $event)" />
  </div>
</template>
<script>
import { display, dateTime, statusTone } from './model'
import { RUN_COLUMNS } from './runColumns'
import AppTableText from '@/components/AppTableText.vue'
import AppTableUser from '@/components/AppTableUser.vue'
import { processedCount } from '@/views/crm/task-tracker/leadFollowUpProgress'
export default {
  components: { AppTableText, AppTableUser },
  props: { data: Object, page: Number, showId: Boolean, listQuery: { type: Object, default: () => ({}) } },
  computed: { columns() { return this.showId ? [{ key: 'run', label: 'Run', width: '90px' }, ...RUN_COLUMNS] : RUN_COLUMNS } },
  methods: {
    processedCount,
    display,
    dateTime,
    statusTone,
    attentionLabel(reason) {
      const count = reason.affected_items > 1 ? ` · ${reason.affected_items}` : ''
      return `${reason.level === 'send_failed' ? 'Send failed' : 'Not sent'}: ${reason.title}${count}`
    },
    target(run) {
      return { name: 'crm-follow-up-automation-detail', params: { run_id: run.id }, query: this.listQuery }
    },
    openRow(event, run) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) return
      this.$router.push(this.target(run)).catch(() => {})
    }
  }
}
</script>
